import { baseApi, AUTH_TAG } from '@/shared';

import type { TUserInfoResponse } from './types';

export const profileApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getUserInfo: build.query<TUserInfoResponse, void>({
      query: () => ({
        url: '/user/me',
      }),
      // transformResponse: userInfo  Adapter,
      providesTags: [AUTH_TAG],
    }),

  }),
});

export const {
  useGetUserInfoQuery,
} = profileApi;
